import { render, staticRenderFns } from "./AnalyticalData.vue?vue&type=template&id=f89041cc&scoped=true"
import script from "./AnalyticalData.vue?vue&type=script&lang=js"
export * from "./AnalyticalData.vue?vue&type=script&lang=js"
import style0 from "./AnalyticalData.vue?vue&type=style&index=0&id=f89041cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89041cc",
  null
  
)

export default component.exports